var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.envIdChange },
                  model: {
                    value: _vm.paramsData.env_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "env_id", $$v)
                    },
                    expression: "paramsData.env_id"
                  }
                },
                _vm._l(_vm.szgmEnv, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("serverChannel")
                  },
                  on: { change: _vm.serverChange },
                  model: {
                    value: _vm.server_channel,
                    callback: function($$v) {
                      _vm.server_channel = $$v
                    },
                    expression: "server_channel"
                  }
                },
                _vm._l(_vm.serverChannel, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("refresh")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addserver.open(
                        null,
                        false,
                        _vm.serverChannel
                      )
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("add")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.list, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "channels",
              label: _vm.$t("groupServerChannel"),
              "min-width": "160"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "groupName", label: "pkg", "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [_vm._v(" " + _vm._s(row.pkg.join(",")) + " ")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "groupName",
              label: _vm.$t("groupName"),
              "min-width": "100"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "group_id",
              label: _vm.$t("groupId"),
              "min-width": "160"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "server_ids",
              label: _vm.$t("groupServerId"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              "min-width": "70",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.addserver.open(row, true)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("modify")) + " ")]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("addserver", {
        ref: "addserver",
        attrs: { propsData: { env_id: _vm.paramsData.env_id } },
        on: { update: _vm.getList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }